export default __webpack_public_path__ + "static/media/undereyeDarknessActive.8673d2e3.svg";